resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function Parallax() {
    this.extends = [_ResponsiveLayout];
    this.node = null;
    this.id = null;
    this.declaredClass = null;

    // Parameters
    this.backgroundPosition = "50% 50%"; // Supports only percentages and pixels
    this.imageUrl = "";
    this.image = null;
    this.rate = 0.25;

    this._error = false;
    this._yPos = 0;
    this._xPos = 0;
    this._yPosAbs = 0;
    this._imgWidth = 0;
    this._imgHeight = 0;
    this._windowEndPos = 0;

    this.init = function() {
        // Load image
        this.image = new Image();
        this.image.src = this.imageUrl;

        // Set properties
        $(this.node).css("background-position", this.backgroundPosition);
        $(this.node).css("background-size", "cover");
        $(this.node).css("background-repeat", "no-repeat");

        var temp = this.backgroundPosition.split(" ");
        this._xPos = temp[0];
        this._yPos = temp[temp.length - 1];

        // Add callback
        $(this.image).on("load", $.proxy(this.onLoadImage, this));
        $(this.image).on("error", $.proxy(this.onLoadImageError, this));
    };

    this.initAllReady = function() {};

    this.onLoadImage = function() {
        if (this._error)
            return;

        // Hide
        $(this.node).css("visibility", "hidden");
        $(this.node).css("display", "block");

        // Get parameters
        this._imgHeight = this.image.height;
        this._imgWidth = this.image.width;
        this._imgRatio = this._imgWidth/this._imgHeight;
        $(this.node).css("background-image", "url('" + this.imageUrl + "')");

        // Connections
        $(window).on("scroll", $.proxy(this.scroll, this));
        this.registerResponsiveFunction($.proxy(this.resize, this), null, null);

        // Calculate
        this.resize();
        $(this.node).css("visibility", "visible");
    };

    this.onLoadImageError = function() {
        this._error = true;
    };

    this.resize = function() {
        // Update parameters
        this._windowEndPos = $(window).outerHeight();

        // Move bg-image
        if (this._yPos.indexOf("%") >= 0) {
            // Calculate
            var divHeight = $(this.node).outerHeight();
            var divWidth = $(this.node).outerWidth();
            var divRatio = divWidth/divHeight;

            var pct = 0;
            if (divRatio > this._imgRatio) {
                pct = parseFloat(this._yPos)/100;
            }
            var ratio = divWidth/this._imgWidth;
            var fullImageHeight = ratio * this._imgHeight;
            var difference = divHeight - fullImageHeight;
            this._yPosAbs = (difference * pct);
        } else {
            this._yPosAbs = parseFloat(this._yPos);
        }
        $(this.node).css("background-position", this._xPos + " " + (Math.round(this._yPosAbs) + "px"));

        // Call scroll
        this.scroll();
    };

    this.scroll = function() {
        var curScroll = $(window).scrollTop();
        var curEndScroll = $(window).scrollTop() + this._windowEndPos;
        var imgStartPosRel = Math.max($(this.node).offset().top - $(window).height(), 0);
        var imgStartPos = $(this.node).offset().top;
        var imgEndPos = imgStartPos + $(this.node).outerHeight();
        var difference = 0;
        if (imgStartPos <= curEndScroll && imgEndPos >= $(window).scrollTop()) {
            difference = curScroll - imgStartPosRel;
            var newPos = Math.round(this._yPosAbs) + (difference * this.rate);
            $(this.node).css("background-position", this._xPos + " " + (newPos + "px"));
        }
    };
}
